import { openModal } from '@core/components/ModalStack';
import { AddTicketModalProps } from './AddTicketModal';
import { TicketChannelReload } from './../TicketsPage/TicketsPage';

export async function openAddTicketModal(props: AddTicketModalProps) {
  TicketChannelReload.next(null);
  const { AddTicketModal } = await import('./AddTicketModal');

  openModal(AddTicketModal, props);
}
